





















































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import HeadLable from '@/components/HeadLable/index.vue'
import { getGoonsList, deleteGoons, updateGoonsStatus } from '@/api/goons'
import InputAutoComplete from '@/components/InputAutoComplete/index.vue'
import Empty from '@/components/Empty/index.vue'
import { getToken } from '@/utils/cookies'

@Component({
  name: 'Goons',
  components: {
    HeadLable,
    InputAutoComplete,
    Empty,
  },
})
export default class extends Vue {
  private input: any = ''
  private counts: number = 0
  private page: number = 1
  private pageSize: number = 10
  private tableData = []
  private id = ''
  private isSearch: boolean = false
  private detailDialogVisible: boolean = false
  private currentDetail: any = null
  private albumUrls: string[] = []

  created() {
    this.init()
  }

  initProp(val) {
    this.input = val
    this.initFun()
  }

  initFun() {
    this.page = 1
    this.init()
  }

  private async init(isSearch?: boolean) {
    this.isSearch = isSearch
    const params = {
      page: this.page,
      pageSize: this.pageSize,
      name: this.input ? this.input : undefined,
    }
    await getGoonsList(params)
      .then((res: any) => {
        if (String(res.data.code) === '1') {
          this.tableData = res.data && res.data.data && res.data.data.records
          this.counts = res.data.data.total
        }
      })
      .catch((err) => {
        this.$message.error('请求出错了：' + err.message)
      })
  }

  // 添加
  private addGoonsHandle(st: string) {
    console.log('addGoonsHandle被调用，参数:', st)
    if (st === 'add') {
      console.log('跳转到添加页面')
      this.$router.push({ path: '/dashou/add' })
    } else {
      console.log('跳转到修改页面，ID:', st)
      this.$router.push({ path: '/dashou/add', query: { id: st } })
    }
  }

  // 删除
  private deleteHandle(id: string) {
    this.$confirm('确认删除该员工信息, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      deleteGoons(id)
        .then((res) => {
          if (res.data.code === 1) {
            this.$message.success('删除成功！')
            this.init()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          this.$message.error('请求出错了：' + err.message)
        })
    })
  }

  //状态修改
  private statusHandle(row: any) {
    this.id = row.id
    const newStatus = row.isWorking === 1 ? 0 : 1
    this.$confirm(`确认将该员工状态修改为${newStatus === 1 ? '工作中' : '休息中'}?`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      updateGoonsStatus({ id: this.id, status: newStatus })
        .then((res) => {
          if (res.data.code === 1) {
            this.$message.success('状态更改成功！')
            this.init()
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .catch((err) => {
          this.$message.error('请求出错了：' + err.message)
        })
    })
  }

  private handleSizeChange(val: any) {
    this.pageSize = val
    this.init()
  }

  private handleCurrentChange(val: any) {
    this.page = val
    this.init()
  }
  
  // 查看员工详情
  private viewDetail(row: any) {
    this.currentDetail = { ...row }
    this.detailDialogVisible = true
    
    // 处理相册图片
    if (row.photoAlbum) {
      const photoIds = row.photoAlbum.split(',').filter((id: string) => id.trim())
      if (photoIds.length > 0) {
        // 调用后端API获取图片URL
        this.fetchAlbumUrls(photoIds);
      } else {
        this.albumUrls = []
      }
    } else {
      this.albumUrls = []
    }
  }
  
  // 获取相册图片URL
  private async fetchAlbumUrls(photoIds: string[]) {
    try {
      console.log('请求相册图片URL，图片ID:', photoIds);
      
      // 获取认证token
      const token = getToken();
      console.log('认证Token:', token ? '已获取' : '未获取');
      
      // 调用批量获取图片URL的API
      const apiUrl = `/api/admin/common/images?ids=${photoIds.join(',')}`;
      console.log('请求URL:', apiUrl);
      
      const response = await fetch(apiUrl, {
        headers: {
          'Content-Type': 'application/json',
          'token': token || ''
        }
      });
      console.log('API响应状态:', response.status, response.statusText);
      
      // 先检查响应类型
      const contentType = response.headers.get('content-type');
      console.log('响应Content-Type:', contentType);
      
      if (!contentType || !contentType.includes('application/json')) {
        console.error('响应不是JSON格式:', await response.text().catch(e => '无法读取响应内容'));
        this.albumUrls = [];
        return;
      }
      
      const data = await response.json();
      console.log('API响应数据:', data);
      
      if (data && data.code === 1 && data.data) {
        // 设置相册URL
        this.albumUrls = data.data.map(item => item.url || '');
        console.log('获取到的相册图片URL:', this.albumUrls);
      } else {
        console.error('批量获取图片URL失败:', data);
        // 如果批量API调用失败，使用单个请求方式获取
        this.albumUrls = [];
        for (const id of photoIds) {
          try {
            const singleApiUrl = `/api/admin/common/image/${id}`;
            console.log('请求单张图片URL:', singleApiUrl);
            
            const res = await fetch(singleApiUrl, {
              headers: {
                'Content-Type': 'application/json',
                'token': token || ''
              }
            });
            console.log(`单张图片(${id})响应状态:`, res.status, res.statusText);
            
            // 检查响应类型
            const singleContentType = res.headers.get('content-type');
            if (!singleContentType || !singleContentType.includes('application/json')) {
              console.error(`单张图片(${id})响应不是JSON格式:`, await res.text().catch(e => '无法读取响应内容'));
              continue;
            }
            
            const imgData = await res.json();
            console.log(`单张图片(${id})响应数据:`, imgData);
            
            if (imgData && imgData.code === 1 && imgData.data) {
              this.albumUrls.push(imgData.data);
              console.log(`获取单张图片(${id})URL:`, imgData.data);
            }
          } catch (err) {
            console.error('获取单张图片URL失败:', err);
          }
        }
      }
    } catch (error) {
      console.error('获取相册图片URL失败:', error);
      this.albumUrls = [];
    }
  }
}
